import { render, staticRenderFns } from "./backHeader.vue?vue&type=template&id=a98adf68&scoped=true&"
import script from "./backHeader.vue?vue&type=script&lang=ts&"
export * from "./backHeader.vue?vue&type=script&lang=ts&"
import style0 from "./backHeader.vue?vue&type=style&index=0&id=a98adf68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98adf68",
  null
  
)

export default component.exports